import { CountrySelectorValue, HeaderSlotsValue } from '@headless-workspace/core-domain';
import { PropsWithLocale } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { BasketSummaryContainer, WishlistContainer } from '../../../../../src';
import { HeaderSlots } from './HeaderSlots';
import { HeaderSwitcher } from './HeaderSwitcher';

type HeaderUtilitiesProps = PropsWithLocale & {
    hostUrl: string | null;
    isEnableOffers?: boolean;
    totalForFreeShipping: number;
    enablePriceExceptionLegalMentions: boolean;
    headerSlots?: HeaderSlotsValue;
    countrySelector?: CountrySelectorValue;
};

/**
 * @returns Search icon, header slots, wishlist container and basket summary (all centered/right icons in the header)
 */
export const HeaderUtilities: Component<HeaderUtilitiesProps> = ({
    hostUrl,
    isEnableOffers,
    totalForFreeShipping,
    enablePriceExceptionLegalMentions,
    headerSlots,
    countrySelector,
    locale,
}) => {
    return (
        <div className={'flex flex-row justify-center items-center h-full'}>
            {headerSlots && (
                <HeaderSlots
                    hostUrl={hostUrl ?? ''}
                    isEnableOffers={isEnableOffers}
                    locale={locale}
                    headerSlots={headerSlots}
                />
            )}
            <WishlistContainer locale={locale} />
            <BasketSummaryContainer
                locale={locale}
                totalForFreeShipping={totalForFreeShipping}
                enablePriceExceptionLegalMentions={enablePriceExceptionLegalMentions}
            />
            <HeaderSwitcher locale={locale} hostUrl={hostUrl} countrySelector={countrySelector} />
        </div>
    );
};
